var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyStateSalesforce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 36,
    viewBox: "0 0 118 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmptyStateSalesforce_svg__filter0_d_555_51129)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#E1E9F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.453 8.385H18v15.23h-3.547c-1.415 0-1.928-.147-2.445-.423a2.883 2.883 0 01-1.2-1.2c-.276-.517-.423-1.03-.423-2.444v-7.096c0-1.414.147-1.927.424-2.444a2.883 2.883 0 011.199-1.2c.517-.276 1.03-.423 2.445-.423z",
    fill: "#148CFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.385h3.548c1.414 0 1.927.147 2.444.423.517.277.923.683 1.2 1.2.276.517.423 1.03.423 2.444V16H18V8.385z",
    fill: "#4DB1FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.615 16v3.548c0 1.414-.147 1.927-.423 2.444a2.884 2.884 0 01-1.2 1.2c-.517.276-1.03.423-2.444.423H18V16h7.615z",
    fill: "#F2FAFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 16h12",
    stroke: "#E1E9F0",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "1 3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 25a9 9 0 119-9 9 9 0 01-9 9zm4.5-10.5h-9a.75.75 0 010-1.5h9a.75.75 0 010 1.5zM56 16h6a.75.75 0 010 1.5h-6a.75.75 0 010-1.5zm1.5 3h3a.75.75 0 010 1.5h-3a.75.75 0 010-1.5z",
    fill: "url(#EmptyStateSalesforce_svg__paint0_linear_555_51129)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16h12",
    stroke: "#E1E9F0",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "1 3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmptyStateSalesforce_svg__filter1_d_555_51129)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#E1E9F0"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.49 11.128a3.17 3.17 0 012.283-.969c1.188 0 2.225.655 2.777 1.628a3.875 3.875 0 011.569-.33A3.876 3.876 0 01109 15.33a3.876 3.876 0 01-4.645 3.797 2.84 2.84 0 01-2.476 1.437 2.85 2.85 0 01-1.241-.283 3.238 3.238 0 01-2.979 1.95 3.236 3.236 0 01-3.037-2.095 3.003 3.003 0 01-2.12-5.54 3.404 3.404 0 01-.287-1.373c0-1.907 1.565-3.453 3.496-3.453 1.133 0 2.14.533 2.78 1.36",
    fill: "#00A1E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "EmptyStateSalesforce_svg__filter0_d_555_51129",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.482886 0 0 0 0 0.544786 0 0 0 0 0.599808 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_555_51129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_555_51129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "EmptyStateSalesforce_svg__filter1_d_555_51129",
    x: 82,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.482886 0 0 0 0 0.544786 0 0 0 0 0.599808 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_555_51129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_555_51129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "EmptyStateSalesforce_svg__paint0_linear_555_51129",
    x1: 50,
    y1: 7,
    x2: 50,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EDC9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DC463"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateSalesforce);
export default ForwardRef;